export default __webpack_public_path__ + "static/media/u_wdt_c_2.4a4727b9.mp3";